export default function infinityText(){
    document.addEventListener('DOMContentLoaded', function() {
        const track = document.querySelector('.js-marquee');
        if (!track) return;
    
        // Duplica os itens para criar o loop infinito
        const items = [...track.children];
        items.forEach(item => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
        });
    
        let speed = 0.5; // quanto maior, mais rápido
        let position = 0;
        let trackWidth = track.scrollWidth / 2;
    
        function animate() {
            position -= speed;
    
            if (Math.abs(position) >= trackWidth) {
                position = 0;
            }
    
            track.style.transform = `translateX(${position}px)`;
            requestAnimationFrame(animate);
        }
    
        animate();
    })
}